import { format, getYear, isToday, isWithinInterval, isYesterday, subDays } from "date-fns";
import { IdentifiedPatientState } from "healthex-common/consent.dtos";
import React from "react";
import { getObservableT, i18nGetDateFnsLocale } from "./Infra/i18next";
import { AzureChip, ForestChip, ScarletChip, SlateChip, TangerineChip } from "./UI/HXDesktopChips.styles";
const t = getObservableT("patients");
export const getPatientDateString = (date) => {
    if (!date)
        return "";
    const locale = i18nGetDateFnsLocale();
    const targetDate = new Date(date);
    const now = new Date();
    if (isToday(targetDate)) {
        return t("Today");
    }
    else if (isYesterday(targetDate)) {
        return t("Yesterday");
    }
    else if (isWithinInterval(targetDate, {
        start: subDays(now, 7),
        end: now,
    })) {
        return format(targetDate, "EEEE", { locale });
    }
    else if (getYear(targetDate) === getYear(now)) {
        return format(targetDate, "LLL d", { locale });
    }
    else {
        return format(targetDate, "yyyy-MM-dd", { locale });
    }
};
export function getPatientStatusChip(consent) {
    if (consent.pending) {
        return React.createElement(ScarletChip, { label: t("Action needed") });
    }
    switch (consent.state) {
        case IdentifiedPatientState.ENROLLING:
            return React.createElement(ScarletChip, { label: t("Action needed") });
        case IdentifiedPatientState.ENROLLING_INTERESTED:
        case IdentifiedPatientState.ENROLLING_CONTACTED:
            return React.createElement(AzureChip, { label: t("Expressed interest") });
        case IdentifiedPatientState.ENROLLED:
        case IdentifiedPatientState.REMOVED:
            if (consent.updateRecordsNeeded) {
                return React.createElement(ScarletChip, { label: t("Action needed") });
            }
            if (consent.recordsRetrievalNeeded) {
                return React.createElement(ScarletChip, { label: t("Action needed") });
            }
            return React.createElement(ForestChip, { label: t("Active") });
        case IdentifiedPatientState.DECLINED_ENROLLMENT:
            return React.createElement(TangerineChip, { label: t("Declined") });
        case IdentifiedPatientState.REVOKED_ENROLLMENT:
            return React.createElement(SlateChip, { label: t("Ended") });
        default:
            return null;
    }
}
